import axios from "axios";
import { API_URL } from "../utils/EnvVars";

const getCourseRating = async ({ websiteId, courseId }) => {
  try {
    const res = await axios.get(API_URL + "/app/web-course-reviewz/v2", {
      params: {
        websiteId: websiteId,
        courseId: courseId,
      },
      headers: { "Content-Type": "application/json" },
    });
    const data = res?.data?.obj ?? null;

    if (data) {
      return {
        reviewsCount: data?.reviewsCount,
        averageRating: data?.rating?.averageRating,
      };
    }
    return null;
  } catch (error) {
    console.log(error);
  }
  return null;
};

export default getCourseRating;
